import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "character-info status" }
const _hoisted_2 = { class: "character-info" }
const _hoisted_3 = { rowspan: "2" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "character-info" }
const _hoisted_8 = { rowspan: "2" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "title" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 1,
  class: "character-info"
}
const _hoisted_13 = {
  colspan: "2",
  class: "title"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "key" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "key" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "key" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = {
  key: 2,
  class: "character-info"
}
const _hoisted_25 = {
  colspan: "2",
  class: "title"
}
const _hoisted_26 = { class: "key" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "key" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = {
  key: 3,
  class: "character-info"
}
const _hoisted_33 = {
  colspan: "2",
  class: "title"
}
const _hoisted_34 = { class: "key" }
const _hoisted_35 = { class: "value" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "key" }
const _hoisted_39 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.mode == 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("table", _hoisted_1, [
                _createElementVNode("caption", null, _toDisplayString(_ctx.displayName("ステータス")), 1),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statsInfoList, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.displayName(item.key)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.displayStatValue(item.key, item.value)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("table", _hoisted_2, [
                _createElementVNode("caption", null, _toDisplayString(_ctx.displayName("命ノ星座")), 1),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.constellationInfoList, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_3, [
                          _createElementVNode("img", {
                            class: "icon",
                            src: item.icon_url,
                            alt: item.名前
                          }, null, 8, _hoisted_4)
                        ]),
                        _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.displayName("第" + (index + 1) + "重")) + " " + _toDisplayString(_ctx.displayName(item.名前)), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          class: "description",
                          innerHTML: item.説明
                        }, null, 8, _hoisted_6)
                      ])
                    ], 64))
                  }), 128))
                ])
              ]),
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("caption", null, _toDisplayString(_ctx.displayName("固有天賦")), 1),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passiveTalentInfoList, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("img", {
                            class: "icon",
                            src: item.icon_url,
                            alt: item.名前
                          }, null, 8, _hoisted_9)
                        ]),
                        _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.displayName(item.名前)), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          class: "description",
                          innerHTML: item.説明
                        }, null, 8, _hoisted_11)
                      ])
                    ], 64))
                  }), 128))
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.mode == 2)
          ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
              _cache[0] || (_cache[0] = _createElementVNode("caption", null, null, -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.displayName(_ctx.characterMaster.通常攻撃.名前)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", {
                    colspan: "2",
                    class: "description",
                    innerHTML: _ctx.characterMaster.通常攻撃.説明
                  }, null, 8, _hoisted_14)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talentNormalAttack('通常攻撃').詳細, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (item.名前 && !item.名前.startsWith('非表示_'))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                          _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.displayName(item.名前)), 1),
                          _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.talentValue(item.数値, _ctx.levelNormalAttack("通常攻撃"))), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talentNormalAttack('重撃').詳細, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (item.名前 && !item.名前.startsWith('非表示_'))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                          _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.displayName(item.名前)), 1),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.talentValue(item.数値, _ctx.levelNormalAttack("重撃"))), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talentNormalAttack('落下攻撃').詳細, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (item.名前 && !item.名前.startsWith('非表示_'))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                          _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.displayName(item.名前)), 1),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.talentValue(item.数値, _ctx.levelNormalAttack("落下攻撃"))), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode == 3)
          ? (_openBlock(), _createElementBlock("table", _hoisted_24, [
              _cache[1] || (_cache[1] = _createElementVNode("caption", null, null, -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.displayName(_ctx.characterMaster.元素スキル.名前)), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talentAttributes(_ctx.characterMaster.元素スキル, _ctx.elementalSkillLevel), (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.displayName(item[0])), 1),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(item[1]), 1)
                  ]))
                }), 128)),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", {
                    colspan: "2",
                    class: "description",
                    innerHTML: _ctx.characterMaster.元素スキル.説明
                  }, null, 8, _hoisted_28)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.characterMaster.元素スキル.詳細, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (item.名前 && !item.名前.startsWith('非表示_'))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                          _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.displayName(item.名前)), 1),
                          _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.talentValue(item.数値, _ctx.elementalSkillLevel)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode == 4)
          ? (_openBlock(), _createElementBlock("table", _hoisted_32, [
              _cache[2] || (_cache[2] = _createElementVNode("caption", null, null, -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.displayName(_ctx.characterMaster.元素爆発.名前)), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talentAttributes(_ctx.characterMaster.元素爆発, _ctx.elementalBurstLevel), (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.displayName(item[0])), 1),
                    _createElementVNode("td", _hoisted_35, _toDisplayString(item[1]), 1)
                  ]))
                }), 128)),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", {
                    colspan: "2",
                    class: "description",
                    innerHTML: _ctx.characterMaster.元素爆発.説明
                  }, null, 8, _hoisted_36)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.characterMaster.元素爆発.詳細, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (item.名前 && !item.名前.startsWith('非表示_'))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                          _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.displayName(item.名前)), 1),
                          _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.talentValue(item.数値, _ctx.elementalBurstLevel)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}